<template>

	<section id="Software">

		<div id="Title">

			{{ $t('softwareSolutions') }}

		</div>

		<div class="cont">

			<div id="Text">

				{{ $t('zeissHasOtherAdvanced') }}

			</div>

			<div id="Video">

				<img :src="videoImage()" @click="showVideoPopup = true" alt="Video" />

			</div>

			<div id="VideoPopup" v-if="showVideoPopup" style="background-color: #1d8acb;">

				<video controls autoplay>

					<source :src="videoPopup()" />

				</video>

				<img class="close" @click="showVideoPopup = false" src="/image/close.png" alt="Close" />

			</div>

		</div>

	</section>

</template>

<script>

	import i18n from '@/plugins/i18n';

	export default {
		data () {
			return {
				showVideoPopup: false
			};
		},
		methods: {
			videoPopup () {

				return `/image/xrayseries/software/software.${ i18n.locale }.mp4`;

			},
			videoImage () {

				return `/image/xrayseries/software/software.${ i18n.locale }.png`;

			}
		},
	};

</script>
